import { useMemo } from 'react';
import {
  getMonumentWatermarkStyle,
  getMonumentWatermarkUrl,
  pickPageLoadMonument,
  type MonumentWatermark,
} from '../components/dashboard/monumentWatermarks';

export interface UseMonumentWatermarkResult {
  monument: MonumentWatermark;
  url: string;
  nameEn: string;
  nameGr: string;
  style: Record<string, string>;
}

/** Random Greek museum watermark — new on each refresh, shared during SPA navigation. */
export function useMonumentWatermark(): UseMonumentWatermarkResult {
  const monument = useMemo(() => pickPageLoadMonument(), []);

  return useMemo(
    () => ({
      monument,
      url: getMonumentWatermarkUrl(monument),
      nameEn: monument.nameEn,
      nameGr: monument.nameGr,
      style: getMonumentWatermarkStyle(monument),
    }),
    [monument]
  );
}

export default useMonumentWatermark;
